import { useEffect, useState } from "react";

import { usePermissions } from "Flocknote/apiHooks";
import { useSettingsButtonRef } from "NavBar/navBarStore";
import { useIsSettingsButtonFlashing } from "NavBar/stateHooks";

import FnrButtonPopper from "UI/FnrButtonPopper";
import FnrContainedIcon from "UI/FnrContainedIcon";

import {
  useIsHovered,
  useIsFocusVisible,
} from "Utilities/Hooks/useIsHoverFocused";

import { hoverTextKeys, useHoverTextKey } from "../accountAndSettingsStore";
import ButtonSizer from "../ButtonSizer";
import PopperButton from "../PopperButton";

import PopperContent from "./PopperContent";

const SettingsButton = () => {
  const [closeTrigger, setCloseTrigger] = useState({});
  const settingsButtonRef = useSettingsButtonRef();
  const isSettingsButtonFlashing = useIsSettingsButtonFlashing();
  const [, setHoverTextKey] = useHoverTextKey();
  const isHovered = useIsHovered(settingsButtonRef);
  const isFocusVisible = useIsFocusVisible(settingsButtonRef);
  const [
    {
      canSeeNetworkSettingsNav,
      canSeeNetworkSecurityNav,
      canSeeBillingNav,
      canViewContactSettings,
      canViewSocialAndSharing,
    },
  ] = usePermissions();

  const hasAnySettingsPermission =
    canSeeNetworkSettingsNav ||
    canSeeNetworkSecurityNav ||
    canSeeBillingNav ||
    canViewContactSettings ||
    canViewSocialAndSharing;

  useEffect(() => {
    if (isHovered || isFocusVisible) setHoverTextKey(hoverTextKeys.settings);
    else setHoverTextKey(hoverTextKeys.noHover);
  }, [isHovered, isFocusVisible, setHoverTextKey]);

  if (!hasAnySettingsPermission) return null;

  return (
    <FnrButtonPopper
      ref={settingsButtonRef}
      content={<PopperContent setCloseTrigger={setCloseTrigger} />}
      Button={PopperButton}
      buttonProps={{
        "data-cy": "NavBar_SettingsButton",
        isFlashing: isSettingsButtonFlashing,
      }}
      closeTrigger={closeTrigger}
      autoFocus
    >
      <ButtonSizer>
        <FnrContainedIcon noPadding color="textLight" icon="cog fas" />
      </ButtonSizer>
    </FnrButtonPopper>
  );
};

export default SettingsButton;
